export default function () {
    return {
        deliveryRequests: [],
        selectedDeliveryRequest: {},
    };
}
